// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reports__content {\n  width: 100%;\n  height: 100%;\n}\n.reports__content iframe {\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
